import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './styles/index.css';
import './styles/Sidebar.css';
import './styles/Navbar.css';
import './styles/DataTable.css';
import './styles/FormModal.css';
import './styles/Pages.css';
import './styles/CarteraCreditos.css';
import './styles/Agrupaciones.css';
import './App.css';

import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Sidebar from './components/Sidebar';
import Navbar from './components/Navbar';
import AmbienteBanner from './components/AmbienteBanner';
import { ToastProvider } from './components/ToastProvider';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import ClienteNuevo from './pages/ClienteNuevo';
import ClienteExpediente from './pages/ClienteExpediente';
import ClienteEditar from './pages/ClienteEditar';
import Creditos from './pages/Creditos';
import CreditoNuevo from './pages/creditos/CreditoNuevo';
import CreditoExpediente from './pages/creditos/CreditoExpediente';
import Grupos from './pages/agrupaciones/Grupos';
import Colocadoras from './pages/agrupaciones/Colocadoras';
import SinVinculacion from './pages/agrupaciones/SinVinculacion';
import AgrupacionExpediente from './pages/agrupaciones/AgrupacionExpediente';
import Cobranza from './pages/cobranza/Cobranza';
import Pagos from './pages/Pagos';
import Catalogos from './pages/Catalogos';
import Usuarios from './pages/Usuarios';
import Perfil from './pages/Perfil';
import CobranzaDiaria from './pages/reportes/CobranzaDiaria';
import CierreCaja from './pages/reportes/CierreCaja';

import { healthAPI } from './services/api';

function AppLayout() {
  const [apiOnline, setApiOnline] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    healthAPI
      .check()
      .then(() => setApiOnline(true))
      .catch(() => setApiOnline(false));
  }, []);

  // Si la ruta es login, renderizar sin la carcasa operativa
  if (location.pathname === '/login') {
    if (isAuthenticated) {
      return <Navigate to="/dashboard" replace />;
    }
    return <Login />;
  }

  return (
    <div className="App-main">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="main-content">
        <Navbar onMenuClick={() => setSidebarOpen(true)} />

        <div className="page-content">
          <Routes>
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

            <Route path="/clientes" element={<ProtectedRoute requiredPermission="CLIENTES_VER"><Clientes /></ProtectedRoute>} />
            <Route path="/clientes/nuevo" element={<ProtectedRoute requiredPermission="CLIENTES_CREAR"><ClienteNuevo /></ProtectedRoute>} />
            <Route path="/clientes/:id" element={<ProtectedRoute requiredPermission="CLIENTES_VER"><ClienteExpediente /></ProtectedRoute>} />
            <Route path="/clientes/:id/editar" element={<ProtectedRoute requiredPermission="CLIENTES_EDITAR"><ClienteEditar /></ProtectedRoute>} />

            <Route path="/creditos" element={<ProtectedRoute requiredPermission="CREDITOS_VER"><Creditos /></ProtectedRoute>} />
            <Route path="/creditos/nuevo" element={<ProtectedRoute requiredPermission="CREDITOS_CREAR"><CreditoNuevo /></ProtectedRoute>} />
            <Route path="/creditos/:id" element={<ProtectedRoute requiredPermission="CREDITOS_VER"><CreditoExpediente /></ProtectedRoute>} />

            <Route path="/cartera" element={<ProtectedRoute requiredPermission="CREDITOS_VER"><Creditos /></ProtectedRoute>} />
            <Route path="/cartera/:id" element={<ProtectedRoute requiredPermission="CREDITOS_VER"><CreditoExpediente /></ProtectedRoute>} />

            <Route path="/grupos" element={<ProtectedRoute requiredPermission="AGRUPACIONES_VER"><Grupos /></ProtectedRoute>} />
            <Route path="/grupos/sin-vinculacion" element={<ProtectedRoute requiredPermission="AGRUPACIONES_VER"><SinVinculacion tipo="GRUPAL" /></ProtectedRoute>} />
            <Route path="/grupos/:id" element={<ProtectedRoute requiredPermission="AGRUPACIONES_VER"><AgrupacionExpediente tipo="GRUPAL" /></ProtectedRoute>} />

            <Route path="/colocadoras" element={<ProtectedRoute requiredPermission="AGRUPACIONES_VER"><Colocadoras /></ProtectedRoute>} />
            <Route path="/colocadoras/sin-vinculacion" element={<ProtectedRoute requiredPermission="AGRUPACIONES_VER"><SinVinculacion tipo="COLOCADORA" /></ProtectedRoute>} />
            <Route path="/colocadoras/:id" element={<ProtectedRoute requiredPermission="AGRUPACIONES_VER"><AgrupacionExpediente tipo="COLOCADORA" /></ProtectedRoute>} />

            <Route path="/agrupaciones" element={<Navigate to="/grupos" replace />} />
            <Route path="/agrupaciones/:id" element={<ProtectedRoute requiredPermission="AGRUPACIONES_VER"><AgrupacionExpediente /></ProtectedRoute>} />

            <Route path="/cobranza" element={<ProtectedRoute requiredPermission="COBRANZA_VER"><Cobranza /></ProtectedRoute>} />
            <Route path="/pagos" element={<ProtectedRoute requiredPermission="PAGOS_VER"><Pagos /></ProtectedRoute>} />
            <Route path="/catalogos" element={<ProtectedRoute><Catalogos /></ProtectedRoute>} />

            <Route path="/reportes/cobranza-diaria" element={<ProtectedRoute requiredPermission="COBRANZA_VER"><CobranzaDiaria /></ProtectedRoute>} />
            <Route path="/reportes/cierre-caja" element={<ProtectedRoute requiredPermission="COBRANZA_VER"><CierreCaja /></ProtectedRoute>} />
            <Route path="/reportes" element={<Navigate to="/reportes/cobranza-diaria" replace />} />

            <Route path="/usuarios" element={<ProtectedRoute requiredPermission="USUARIOS_VER"><Usuarios /></ProtectedRoute>} />
            <Route path="/perfil" element={<ProtectedRoute><Perfil /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>

        {apiOnline !== null && (
          <div className={`api-status ${apiOnline ? 'is-online' : 'is-offline'}`}>
            <span className="api-status-dot" />
            {apiOnline ? 'Conectado' : 'Sin conexión'}
          </div>
        )}
      </div>
    </div>
  );
}

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <AmbienteBanner />
        <Router>
          <AppLayout />
        </Router>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
